import React, { useState } from 'react';
import './Login.css';

const Login = ({ onLogin }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    username: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLogin) {
      // Handle login
      console.log('Login attempt:', formData.email);
      const userSession = {
        email: formData.email,
        username: formData.email.split('@')[0],
        loginTime: new Date().toISOString()
      };
      // Call onLogin and let the parent component handle the redirect
      onLogin(userSession);
    } else {
      // Handle registration
      if (formData.password !== formData.confirmPassword) {
        alert('Passwords do not match');
        return;
      }
      console.log('Registration attempt:', formData);
      const userSession = {
        email: formData.email,
        username: formData.username || formData.email.split('@')[0],
        loginTime: new Date().toISOString()
      };
      // Call onLogin and let the parent component handle the redirect
      onLogin(userSession);
    }
  };

  const handleLogout = () => {
    setFormData({
      email: '',
      password: '',
      confirmPassword: '',
      username: ''
    });
  };

  // Remove the isLoggedIn check - let the parent component handle the redirect

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h2>{isLogin ? 'Welcome Back' : 'Create Account'}</h2>
          <p>{isLogin ? 'Sign in to your trading account' : 'Join our trading platform'}</p>
        </div>

        <div className="login-form-container">
          <div className="form-tabs">
            <button 
              className={`tab-btn ${isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(true)}
            >
              Login
            </button>
            <button 
              className={`tab-btn ${!isLogin ? 'active' : ''}`}
              onClick={() => setIsLogin(false)}
            >
              Register
            </button>
          </div>

          <form className="login-form" onSubmit={handleSubmit}>
            {!isLogin && (
              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                  required={!isLogin}
                  placeholder="Choose a username"
                />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required
                placeholder="Enter your password"
              />
            </div>

            {!isLogin && (
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required={!isLogin}
                  placeholder="Confirm your password"
                />
              </div>
            )}

            {isLogin && (
              <div className="form-options">
                <label className="checkbox-label">
                  <input type="checkbox" />
                  <span>Remember me</span>
                </label>
                <a href="#" className="forgot-password">Forgot password?</a>
              </div>
            )}

            <button type="submit" className="submit-btn">
              {isLogin ? 'Sign In' : 'Create Account'}
            </button>

            {isLogin && (
              <div className="social-login">
                <p>Or sign in with</p>
                <div className="social-buttons">
                  <button className="social-btn google">
                    <span>G</span>
                    Google
                  </button>
                  <button className="social-btn github">
                    <span>G</span>
                    GitHub
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>

        <div className="login-features">
          <h3>Why Choose Our Platform?</h3>
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <h4>Secure Trading</h4>
              <p>Bank-level security for all your trades</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">⚡</div>
              <h4>Real-time Data</h4>
              <p>Live market data and instant execution</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🤖</div>
              <h4>AI Trading</h4>
              <p>Advanced algorithms for optimal trading</p>
            </div>
            <div className="feature-item">
              <div className="feature-icon">📊</div>
              <h4>Analytics</h4>
              <p>Comprehensive trading analytics and insights</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;